import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.desktop.shared.patient-authorization': {
         identifierTypeMap: {
            BIRTH_DATE: 'Data urodzenia',
            GUARDIAN_PESEL: 'PESEL opiekuna',
            MEDICAL_RECORD_NUMBER: 'Nr kart.',
            NATIONAL_IDENTIFICATION_NUMBER: 'PIN UE',
            PASSPORT: 'Paszport',
            PESEL: 'PESEL',
         },
      },
   },
};

export const translationKeys = createScopedTranslationKeys(
   translations.pl,
   '~libs.desktop.shared.patient-authorization'
);
